var styleDataHash = "486841b2";
const injectCss = () => {
  var css = `/*! rtl:begin:ignore */.GXGcV{background:rgba(0,0,0,.5);height:100%;position:relative;width:100%}.Dz3cy{animation:RES-8 1.7s ease infinite,_9Ky4s 1.7s ease infinite;border-radius:50%;bottom:0;color:#fbfbfb;font-size:60px;height:1em;left:0;margin:auto;position:absolute;right:0;top:0;width:1em}.Dz3cy.-em6g{font-size:40px}.Dz3cy.BYvFK{font-size:20px}.gJmuw{border-radius:50%;bottom:0;color:#fbfbfb;font-size:60px;height:1.5em;left:0;margin:auto;position:absolute;right:0;text-align:center;top:0;width:3em}.gJmuw.-em6g{font-size:16px}.gJmuw.BYvFK{font-size:12px}._3-8bc{height:100%;width:100%}@keyframes _9Ky4s{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes RES-8{0%{box-shadow:0 -.83em 0 -.4em,0 -.83em 0 -.42em,0 -.83em 0 -.44em,0 -.83em 0 -.46em,0 -.83em 0 -.477em}5%,95%{box-shadow:0 -.83em 0 -.4em,0 -.83em 0 -.42em,0 -.83em 0 -.44em,0 -.83em 0 -.46em,0 -.83em 0 -.477em}10%,59%{box-shadow:0 -.83em 0 -.4em,-.087em -.825em 0 -.42em,-.173em -.812em 0 -.44em,-.256em -.789em 0 -.46em,-.297em -.775em 0 -.477em}20%{box-shadow:0 -.83em 0 -.4em,-.338em -.758em 0 -.42em,-.555em -.617em 0 -.44em,-.671em -.488em 0 -.46em,-.749em -.34em 0 -.477em}38%{box-shadow:0 -.83em 0 -.4em,-.377em -.74em 0 -.42em,-.645em -.522em 0 -.44em,-.775em -.297em 0 -.46em,-.82em -.09em 0 -.477em}to{box-shadow:0 -.83em 0 -.4em,0 -.83em 0 -.42em,0 -.83em 0 -.44em,0 -.83em 0 -.46em,0 -.83em 0 -.477em}}
/*! rtl:end:ignore */`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var loaders_rtlignore_default = {
  "loaderOverlay": "GXGcV",
  "loader": "Dz3cy",
  "load6": "RES-8",
  "spinner": "_9Ky4s",
  "medium": "-em6g",
  "mini": "BYvFK",
  "progress": "gJmuw",
  "preview_img": "_3-8bc"
};
export {
  loaders_rtlignore_default as default,
  injectCss
};
//# sourceMappingURL=loaders.rtlignore-scss.js.map
